import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface TempIconProps extends IconWrapperProps {
  color?: string;
  showBackground?: boolean;
}

const TempIcon = ({ color = 'currentColor', showBackground = true, ...props }: TempIconProps) => (
  <IconWrapper
    viewBox={showBackground ? '0 0 48 48' : '0 0 24 24'}
    width={showBackground ? '48' : '24'}
    height={showBackground ? '48' : '24'}
    {...props}
  >
    {showBackground && <rect width="48" height="48" rx="24" fill="#E9E9E6" />}
    <path
      fill={color}
      fillRule="evenodd"
      d="M14 13.55V4a4 4 0 0 0-8 0v9.55A6 6 0 0 0 4 18a6 6 0 0 0 5 5.91v-2.05a3.97 3.97 0 0 1-1.4-7.04l.4-.3V4a2 2 0 0 1 4 0v10.52l.4.3a3.97 3.97 0 0 1-1.4 7.04v2.05A6 6 0 0 0 16 18c0-1.71-.72-3.3-2-4.45M10 6a1 1 0 0 0-1 1v8.18A3 3 0 0 0 10 21a3 3 0 0 0 1-5.82V7a1 1 0 0 0-1-1m9 5h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m0-4h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-3-3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
  </IconWrapper>
);

export default TempIcon;
